import * as Yup from "yup";
import { FormGroup } from "../../../components/form/models/models";
import { RoleId } from "../../enums/Role";

export const authorisedRepresentativeModalInvite: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "my-3 text-purple font-bold",
      },
      label: "Invite a user to join this KIS Application",
    },
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "my-3",
      },
      label: "Enter the email address of the KIS Kindergarten user that you wish to invite",
    },
    {
      type: "field",
      key: "userEmail",
      fieldType: "input",
      label: "Email",
      validation: Yup.string().required("a response is required").matches(RegExp("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+[.][a-zA-Z]{2,}$"), {
        message: "Please enter a valid email address",
      }),
    },
    {
      type: "component",
      body: () => <></>,
      defaultValue: {
        roleType: RoleId.Kindergarten,
        inviteRedirectUrl: import.meta.env.VITE_POSTLOGOUTREDIRECTURI,
        userLinkDiscriminator: 0,
        authorisationLevel: 0,
      },
    },
  ],
};
